import { ActivityListWidget, NotesListWidget, Widget } from '@aimsos/ui';
import WIDGET_PREVIEW_DATA from '../constants/widgetPreviewData';

/** Detail or mini preview body: notes, activity, or standard `Widget`. */
export function renderWidgetLibraryPreviewBody(widget, previewData, isCompressed) {
  const data = previewData ?? WIDGET_PREVIEW_DATA[widget?.type] ?? null;
  if (!data) return null;

  const type = widget?.type;
  if (type === 'notes') {
    return <NotesListWidget data={data} isCompressed={isCompressed} />;
  }
  if (type === 'activity') {
    return <ActivityListWidget data={data} isCompressed={isCompressed} />;
  }
  return <Widget data={data} />;
}
